import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

export function update(data) {
  return request({
    url: '/user/info/update',
    method: 'post',
    data
  })
}

export function changePassword(data) {
  return request({
    url: '/user/change-password',
    method: 'post',
    data
  })
}

export function uploadAvatar(data) {
  return request({
    url: '/user/upload/avatar',
    method: 'post',
  })
}
